// extracted by mini-css-extract-plugin
export var box = "_80-1";
export var checked = "_80-2";
export var descriptionSpacer = "_80-9";
export var disabled = "_80-3";
export var icon = "_80-6";
export var input = "_80-0";
export var labelSpacer = "_80-8";
export var medium = "_80-5";
export var small = "_80-4";
export var text = "_80-7";